import { Component, OnInit, AfterViewInit, Input, ElementRef } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-time-error',
  templateUrl: './form-time-error.component.html',
  styleUrls: ['./form-time-error.component.scss']
})
export class FormTimeErrorComponent implements OnInit, AfterViewInit {


  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() format: string;
  @Input() required = false;
  @Input() interval = false;
  @Input() expired = false;
  @Input() item: string;
  @Input() mustBeEmpty: false;

  @Input() dateElement: ElementRef;
  @Input() onlyIcon = false;

  constructor() { }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
  }

  getControl(): AbstractControl {
    return this.form.get(this.controlName) ;
  }

}
